import { makeStyles } from '@material-ui/styles'

export const ButtonCustomStyles = makeStyles((theme: any) => ({
    root: {
        '& .default-label': {
            color: '#9e9e9e',
            fontWeight: '400'
        },
        '& .ChangeButtonWidth': {
            minWidth: '140px'
        },
        '& .SecondaryButton:hover': {
            color: '#f2f2f2'
        },
    }
}))
